// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"2626bef4","146":"1ab3b4b3","486":"f277268f","631":"1e181765","937":"9dfcbe44"}[chunkId] + ".chunk.css";
};